(function(app) {

    app.provider("userGroupApi",
    [
        function() {
            this.$get = [
                "portalApiGateway", function (portalApiGateway) {
                    var service = {};

                    service.get = function(userGroupId) {
                        return portalApiGateway.get("/UserGroups/" + userGroupId);
                    };

                    service.getLogo = function(userGroupId) {
                        return portalApiGateway.getFile("/UserGroups/" + userGroupId + "/Logo");
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app);